export default "__VITE_ASSET__$F0UBA90__"